import cn from 'classnames';
import * as React from 'react';
import { ReactNode, useEffect } from 'react';

import { SlotFillManager } from './SlotFillManager';
import styles from './styles.module.scss';

export interface SlotProps {
  slotId?: string;
  className?: string;
  children?: ReactNode;
}

const Slot: React.FC<SlotProps> = ({ slotId, className, children }) => {
  const [fills, setFills] = React.useState<ReactNode[]>([]);

  useEffect(() => {
    if (!slotId) return;

    const updateFills = () => {
      setFills(SlotFillManager.getFills(slotId));
    };

    // Subscribe to changes
    SlotFillManager.subscribe(slotId, updateFills);
    updateFills();

    return () => {
      SlotFillManager.unsubscribe(slotId, updateFills);
    };
  }, [slotId]);

  return (
    <div className={cn(className, styles.slot)} data-slot-id={slotId}>
      {fills.length > 0 ? fills : children}
    </div>
  );
};

export default Slot;
